
import state from './state'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/features/admin/transacoesCompraVenda/store/index.js